
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import ProfileManagementLoaderMixin from "@/components/pages/profile/ProfileManagement/LoaderMixin";
import {defineComponent} from "vue";
import IoablePageMixin from "@/router/IoablePageMixin";
import {Controller} from "@/store/modules/hcs/controller/model";
import {DataProfile} from "@/store/modules/hcs/dataProfile/model";
import {DataComponentModel} from "@/store/modules/hds/Model";
import {TradeContractFormatGroup} from "@/store/modules/hcs/tradeContractFormatGroup/model";
import {mapActions} from "vuex";
import IconBtn from "@/components/molecules/IconBtn.vue";

export default defineComponent({
  name: 'TradeContractCreate',
  components: {
    IconBtn,
    TabPageTemplate, TabItemTemplate,
  },
  mixins: [
    IoablePageMixin.extend({
      beforeRouteUpdate(to, from, next) {
        next();
      }
    }),
    ProfileManagementLoaderMixin,
  ],
  data() {
    return {
      controllers: [] as Controller[],
      dataProfiles: [] as DataProfile[],
      dataComponentModels: [] as DataComponentModel[],
      tradeContractFormatGroups: [] as TradeContractFormatGroup[],
    };
  },
  methods: {
    ...mapActions({
      fetchTradeContractFormatGroups: "hcs/tradeContractFormatGroup/findList",
    }),
    async load() {
      const data = await this.loadData({
        loadControllers: true,
        loadDataProfiles: true,
        loadServiceProfiles: false,
        loadContractProfileTemplates: false,
      });
      this.controllers = data.controllers;
      this.dataProfiles = data.dataProfiles;
      this.dataComponentModels = data.dataComponentModels;
      this.tradeContractFormatGroups = await this.fetchTradeContractFormatGroups();
    },
    tabRoute(name: string) {
      const routeBase = this.$route.name?.replace(/^(\/[^/]+\/[^/]+\/[^/]+\/[^/]+).*$/, '$1');
      return `${routeBase}${name}`;
    }
  }
});
